<template>
  <div>
    <div class="flex justify-end my-5 gap-5">
      <vs-button
              @click.prevent="downloadExcelFile"
              class="bg_m_blue"
              :disabled="excelFileLoading"
              v-if="$tabHasPermission('GetAgentsWithExcelFile')"
            >
              <div class="flex gap-2 items-center">
                <span>{{ $t("DownloadExcelFile") }}</span>
                <img
                  v-if="excelFileLoading"
                  src="@/assets/images/loading.gif"
                  class="w-6 h-6"
                />
              </div>
            </vs-button>
      <filter-button @click="toggleShowFilters" />
    </div>
    <form v-if="showFilters" class="filter-form">
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-4"
            v-model="gridSearchData.Name"
            :label="$t('AgentName')"
          />
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
          <label class="vs-select--label mb-1">{{ $t("AgentType") }}</label>
          <v-select
            label="name"
            :options="customers"
            v-model="gridSearchData.agentTypeQuery"
            :reduce="(x) => x.id"
            :clearable="false"
            ref="agentType"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mt-6">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitFilter()"
            >{{ $t("SubmitFilter") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("ResetFilter") }}</vs-button
          >
        </div>
      </div>
    </form>
    <data-grid
      ref="grid"
      stripe
      v-has-permission="permission240"
      :data-source="gridDataSource"
      :search-data="gridSearchData"
      :columns="[
        { title: $t('Name') },
        { title: $t('AgentID') },
        { title: 'کد نماینده' },
        {
          title: $t('SocialSecurityNumber') + ' / ' + $t('CompanyNationalId'),
        },
        { title: $t('PartyType') },
        { title: $t('Branch') },
        { title: $t('Action') },
      ]"
    >
      <template slot-scope="{ row }">
        <td style="width: 20%">
          <span v-if="row.partyType == 'AgentIndividual'">
            {{ row.firstName }} {{ row.lastName }}
          </span>
          <span v-if="row.partyType == 'AgentLegal'">
            {{ row.companyName }}
          </span>
        </td>
        <td style="width: 8%">
          {{ row.id }}
        </td>
        <td style="width: 8%">
          {{ row.code }}
        </td>
        <td style="width: 15%">
          <span v-if="row.socialSecurityNumber">
            {{ row.socialSecurityNumber }}
          </span>
          <span v-if="row.companyNationalId"> {{ row.companyNationalId }}</span>
          <span v-if="!row.socialSecurityNumber && !row.companyNationalId"
            >-</span
          >
        </td>
        <td style="width: 10%; direction: ltr">
          <span v-if="row.partyType == 'AgentIndividual'">
            {{ $t("Individual") }}
          </span>
          <span v-if="row.partyType == 'AgentLegal'">
            {{ $t("Legal") }}
          </span>
        </td>
        <td style="width: 10%; direction: ltr">
          <span v-if="row.agentBranchInfo == 1"> ندارد </span>
          <span v-else-if="row.agentBranchInfo == 2">دارد</span>
        </td>
        <td style="width: 15%; direction: ltr">
          <div
            class="w-full h-full flex flex-wrap items-center justify-center gap-y-2"
          >
            <span v-if="row.partyType == 'AgentIndividual'">
              <router-link
                :to="{
                  path: '/Agents/EditIndividual/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    ownerUserName: row.agentOwnerQuery.agentOwnerName,
                    isConfirmed:false
                  },
                }"
              >
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  v-has-permission="permission81"
                ></vs-button>

              </router-link>
              <router-link
                :to="{
                  path: '/Agents/ConfirmIndividual/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    ownerUserName: row.agentOwnerQuery.agentOwnerName,
                    isConfirmed:false
                  },
                }"
              >
              <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="d-inline ml-5"
                  v-has-permission="permission81"
                ></vs-button>
              </router-link>
            </span>
            <span v-else-if="row.partyType == 'AgentLegal' && row.id != 0">
              <router-link
                :to="{
                  path: '/Agents/EditLegal/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    typeAgent: row.agentBranchInfo,
                    isConfirmed:false
                  },
                }"
              >
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  v-has-permission="permission81"
                ></vs-button>
              </router-link>
              <router-link
                :to="{
                  path: '/Agents/ConfirmLegal/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    typeAgent: row.agentBranchInfo,
                    isConfirmed:false
                  },
                }"
              >
              <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="d-inline ml-5"
                  v-has-permission="permission81"
                ></vs-button>
              </router-link>
            </span>
          </div>
        </td>
      </template>
    </data-grid>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import FilterButton from "@/components/buttons/FilterButton.vue";
import utils from "@/assets/utils/index";

export default {
  data() {
    return {
      permission240: "GetAllByAgentInfo",
      permission81: "GetAgentRecipientsByOwnerIdInShipping|GetAgentById",
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/AgentsInfoQuery",
      },
      gridSearchData: {
        AgentState:'0'
      },
      showFilters: false,
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      excelFileLoading: false,

    
    };
  },
  methods: {
    ...mapActions({
      exportAgents: "excel/exportAgents",
    }),

    downloadExcelFile() {
      this.excelFileLoading = true;
      var params = utils.toQueryString(this.gridSearchData);
      console.log(params)
      this.exportAgents(params)
        .then(() => {
          this.excelFileLoading = false;
        })
        .catch(() => {
          this.excelFileLoading = false;
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.$refs.agentype.clearSelection();
      }, 0);
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    FilterButton,
  },
};
</script>